module.exports = __webpack_public_path__ + "img/pos.411057f8.gif";